import { Constants } from "./constants";

/* eslint-disable space-before-blocks */
const COMPANY_SECRETARY_FOREIGN_RESIDENT = [
  {
    label: "Passport Photo(On A White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "Passport(BIOS PAGE)", name: "passportBIOS", optional: true },
  { label: "Current Work Permit", name: "workPermit", optional: true },
  { label: "KRA Certificate", name: "KRACert" },
  { label: "Foreigner Certificate", name: "foreignerCert" },
  { label: "ICPSK Practicing Certificate", name: "practicingCert" },
];

const REGULATED_ARTICLES = [{ label: "Choose File", name: "Choose File" }];
const SPECIAL_INSTRUCTIONS = [{ label: "Choose File", name: "Choose File" }];

const COMPANY_SECRETARY_KENYAN = [
  {
    label: "Passport Photo(On A White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "National Id", name: "nationalID" },
  { label: "KRA PIN Certificate", name: "KRACert" },
  { label: "ICPSK Practicing Certificate", name: "practicingCert" },
];

const COMPANY_SECRETARY_LOCAL_COMPANY = [
  { label: "Certificate Of Incorporation", name: "certOfIncorporation" },
  {
    label: "Certificate Of Incumbency",
    name: "certOfIncumbency",
    optional: true,
  },
  { label: "KRA PIN Certificate", name: "KRAPIN" },
  {
    label: " ICPSK Practicing Certificate For Lead Partner",
    name: "leadPartnerCertificate",
  },
];

const FOREIGNER = [
  {
    label: "Passport Photo(On A White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png ",
  },
  { label: "Passport(BIOS PAGE)", name: "passportBIOS" },
];

const FOREIGN_COMPANY = [
  { label: "Certificate Of Incorporation", name: "certOfIncorporation" },
  {
    label: "Memorandum and Articles Of Association",
    name: "articlesOfAssociation",
  },
  {
    label: "Certificate Of Incumbency",
    name: "certOfIncumbency",
    optional: true,
  },
];

const FOREIGN_RESIDENT = [
  {
    label: "Upload Passport Photo(On White-Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "Foreigner Certificate", name: "foreignerCert" },
  { label: "KRA Certificate", name: "KRACert" },
  { label: "Current Work Permit", name: "workPermit", optional: true },
];

const KENYAN_CITIZEN = [
  {
    label: "Upload Passport Photo(On White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "National Id", name: "nationalID" },
  { label: "KRA Certificate", name: "KRACert" },
];
const KENYAN_CITIZEN_EMPLOYEE = [
  {
    label: "Upload Passport Photo(On White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "National Id", name: "nationalID" },
];
const MINOR = [
  {
    label: "Passport Photo(On White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "Birth Certificate", name: "birthCertificate" },
];

const LOCAL_COMPANY = [
  { label: "Certificate Of Incorporation", name: "certOfIncorporation" },
  { label: "KRA Certificate", name: "KRACert" },
  {
    label: "Memorandum And Articles Of Association",
    name: "articlesOfAssociation",
  },
  {
    label: "Official Search Results(FORM CR12)",
    name: "searchResults",
    optional: true,
  },
  {
    label: "Certificate Of Incumbency",
    name: "certOfIncumbency",
    optional: true,
  },
];

const RESIGNATION_OFFICIAL = [
  {
    label: "Letter of Resignation | Template",
    name: "letterOfResignation",
    accept: "image/jpeg, image/jpg, image/png",
  },
  {
    label: "Statutory Declaration | Template",
    name: "statutoryDeclaration",
    accept: "image/jpeg, image/jpg, image/png",
    optional: true,
  },
  {
    label: "Extract of Board Resolution | Template",
    name: "extractOfBoardResolution",
    accept: "image/jpeg, image/jpg, image/png",
    optional: true,
  },
];

const APPOINTMENT_OFFICIAL = [
  {
    label: "Consent to Act as an Authorized Person",
    name: "consentOfAuthorizedPerson",
    accept: "image/jpeg, image/jpg, image/png",
  },
  {
    label: "Form CR6",
    name: "Cr6Form",
    accept: "image/jpeg, image/jpg, image/png",
    // optional: true,
  },
  {
    label: "Form CR8",
    name: "Cr8Form",
    accept: "image/jpeg, image/jpg, image/png",
    // optional: true,
  },
];

const OTHER = [{ label: "Gazette Notice", name: "gazetteNotice" }];

const getEstateDocumentData = (isEstateDistributed) => {
  let estateDocuments = [
    { label: "Copy of ID Card", name: "copyOfIDCard" },
    { label: "Copy of Death Certificate", name: "copyOfDeathCertificate" },
  ];
  if (isEstateDistributed === "Yes") {
    estateDocuments = [
      ...estateDocuments,
      {
        label: "Certificate of Confirmation of Probate",
        name: "certificateOfConfirmationOfProbate",
      },
      {
        label: "Copy of Will/Schedule of Distribution)",
        name: "copyOfWill/ScheduleOfDistribution)",
      },
    ];
  }
  return estateDocuments;
};

const getOnboardingDocuments = (idType) => {
  let documentData = [];
  switch (idType) {
    case Constants.ID_TYPES.KENYAN_CITIZEN:
      documentData = [
        {
          label: "Upload Passport Photo(On White Background)",
          name: "passportPhoto",
          accept: "image/jpeg, image/jpg, image/png",
        },
        { label: "National Id", name: "nationalID" },
      ];
      break;
    case Constants.ID_TYPES.FOREIGN_RESIDENT:
      documentData = [
        {
          label: "Upload Passport Photo(On White-Background)",
          name: "passportPhoto",
          accept: "image/jpeg, image/jpg, image/png",
        },
        { label: "Foreigner Certificate", name: "foreignerCert" },
      ];
      break;
    case Constants.ID_TYPES.FOREIGNER:
      documentData = FOREIGNER;
      break;
    default:
      documentData = [];
  }
  return documentData;
};

const getDocumentData = (idType) => {
  let documentData = [];
  switch (idType) {
    case Constants.ID_TYPES.KENYAN_CITIZEN:
      documentData = KENYAN_CITIZEN;
      break;
    case Constants.ID_TYPES.FOREIGN_RESIDENT:
      documentData = FOREIGN_RESIDENT;
      break;
    case Constants.ID_TYPES.FOREIGNER:
      documentData = FOREIGNER;
      break;
    case Constants.ID_TYPES.LOCAL_COMPANY:
      documentData = LOCAL_COMPANY;
      break;
    case Constants.ID_TYPES.OTHER_PARASTATALS:
      documentData = OTHER;
      break;
    case Constants.ID_TYPES.FOREIGN_COMPANY:
      documentData = FOREIGN_COMPANY;
      break;
    case Constants.ID_TYPES.MINOR:
      documentData = MINOR;
      break;
    default:
      documentData = [];
  }
  return documentData;
};

const getSignOffManageDocuments = (documentType) => {
  let documentData = [];
  switch (documentType) {
    case "consentToAct":
      documentData = [
        {
          label: "Consent to Act as an Authorized Person",
          name: "consentToAct",
          accept: "image/jpeg, image/jpg, image/png",
        },
      ];
      break;
    default:
      documentData = [];
  }
  return documentData;
};
const getDocumentDataForEmployee = (idType) => {
  let documentData = [];
  switch (idType) {
    case Constants.ID_TYPES.KENYAN_CITIZEN:
      documentData = KENYAN_CITIZEN_EMPLOYEE;
      break;
    case Constants.ID_TYPES.FOREIGN_RESIDENT:
      documentData = FOREIGN_RESIDENT;
      break;
    case Constants.ID_TYPES.FOREIGNER:
      documentData = FOREIGNER;
      break;
    default:
      documentData = [];
  }
  return documentData;
};

const getChangedDocumentsModuleData = (processType, idType = "") => {
  let documentData = [];
  switch (processType) {
    case "officials":
      documentData = getDocumentData(idType);
      break;
    case "approvedChangesDocuments":
      documentData = [
        {
          label: "Consent to Act",
          name: "consentFormForAuthorizedPerson",
          accept: "application/pdf",
        },
      ];
      break;

    case "platformConsentResolutionType":
      documentData = [
        {
          label: "Consent Resolution letter",
          name: "consentResolutionType",
          accept: "application/pdf",
        },
      ];
      break;
    case "changeDocuments":
      documentData = [
        {
          label: "Consent to Act",
          name: "consentToAct",
          accept: "application/pdf",
        },
      ];
      break;
    case "directorApprovalDocs":
      documentData = [
        {
          label: "Board Resolutions",
          name: "directorApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;
    case "shareholderApprovalDocs":
      documentData = [
        {
          label: "Shareholder Resolutions",
          name: "shareholderApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;
    case "courtOrderApprovalDocs":
      documentData = [
        {
          label: "Court Order",
          name: "courtOrderApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;
    case "gazetteApprovalDocs":
      documentData = [
        {
          label: "Gazette Notice",
          name: "gazetteApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;
    case "creditorApprovalDocs":
      documentData = [
        {
          label: "Creditor Resolutions",
          name: "creditorApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;
    case "ownConsentResolutionType":
      documentData = [
        {
          label: "Consent Resolution letter",
          name: "consentResolutionType",
          accept: "application/pdf",
        },
      ];
      break;
    case "ownResignationLetterTemplate":
      documentData = [
        {
          label: "Upload your own resignation letter",
          name: "ownResignationLetterTemplate",
          accept: "application/pdf",
        },
      ];
      break;
    case "ownStatutoryDeclarationTemplate":
      documentData = [
        {
          label: "Upload your own Statutory Declaration Template",
          name: "ownStatutoryDeclarationTemplate",
          accept: "application/pdf",
        },
      ];
      break;
    default:
      documentData = [];
  }
  return documentData;
};

const getCompanySecretaryDocumentData = (idType) => {
  let documentData = [];
  switch (idType) {
    case "Kenyan Citizen":
      documentData = COMPANY_SECRETARY_KENYAN;
      break;
    case "Foreign Resident":
      documentData = COMPANY_SECRETARY_FOREIGN_RESIDENT;
      break;
    case "Other":
      documentData = OTHER;
      break;
    case "Local Company":
      documentData = COMPANY_SECRETARY_LOCAL_COMPANY;
      break;
    default:
      documentData = [];
  }
  return documentData;
};

const getMaintainYourCompanyReviewStatus = (status) => {
  const { MAINTAIN_COMPANY_REVIEW_STATUSES } = Constants;
  let statusLabel = "";
  switch (status) {
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DRAFT:
      statusLabel = "Draft";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.ACTIVE:
      statusLabel = "Active";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_APPROVAL:
      statusLabel = "Director Approval";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW:
      statusLabel = "Director Review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_II:
      statusLabel = "Director Review II";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_CORRECTIONS:
      statusLabel = "Director Corrections";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.SHAREHOLDER_APPROVAL:
      statusLabel = "Shareholder Approval";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW:
      statusLabel = "Registrar Review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW_II:
      statusLabel = "Registrar Review II";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL:
      statusLabel = "Registrar Approval";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CORRECTIONS:
      statusLabel = "Registar Corrections";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW:
      statusLabel = "Legal Department Review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_APPROVAL:
      statusLabel = "Legal Department Approval";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL:
      statusLabel = "Director Review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.SHAREHOLDER_REVIEW:
      statusLabel = "Shareholder Review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.SHAREHOLDER_REVIEW_II:
      statusLabel = "Shareholder Review II Approval";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.SHAREHOLDER_CORRECTIONS:
      statusLabel = "Shareholder Corrections";
      break;
    // case MAINTAIN_COMPANY_REVIEW_STATUSES.SHAREHOLDER_REVIEW_APPROVAL:
    // statusLabel = "Shareholder Approval";
    // break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_REVIEW:
      statusLabel = "Admin Review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_REVIEW_II:
      statusLabel = "Admin Review II";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_CORRECTIONS:
      statusLabel = "Admin Corrections";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.SUBMISSION:
      statusLabel = "Submission";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.SUBMISSION_II:
      statusLabel = "Submission II";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.SUBMISSION_CORRECTIONS:
      statusLabel = "Submission Corrections";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_APPROVAL:
      statusLabel = "Pending BRS review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_REVIEW:
      statusLabel = "BRS Review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_REVIEW_II:
      statusLabel = "BRS Review II Approval";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_CORRECTIONS:
      statusLabel = "BRS Corrections";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE:
      statusLabel = "CHANGES SIGNATURE";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_REVIEW:
      statusLabel = "Registrar CS Review";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE_CORRECTIONS:
      statusLabel = "Change Signature Corrections";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE_II:
      statusLabel = "Change Signature II";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_APPROVAL:
      statusLabel = "Register CS Approval";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_SIGNATURE:
      statusLabel = "Directors Signature";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_SIGNATURE_CORRECTIONS:
      statusLabel = "Pending Directors Signature Correction";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_REVIEW:
      statusLabel = "Registrar DR Review ";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_APPROVAL:
      statusLabel = "Registrar DR Approval ";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_FORM_SIGNATURE:
      statusLabel = "BRS Signature ";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.CANCELLATION_NOTICE:
      statusLabel = "Cancellation Notice ";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.CANCELLATION_NOTICE_CORRECTION:
      statusLabel = "Cancellation Notice Correction";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.CANCELLATION_NOTICE_II:
      statusLabel = "Cancellation Notice II";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.AWAITING_COURT_ORDER:
      statusLabel = "Awaiting Court Order";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.INTENDED_DISSOLUTION:
      statusLabel = "Intended Dissolution";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.DISSOLUTION_NOTICE:
      statusLabel = "Dissolution Notice";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.PENDING_REGISTRAR_DECISION:
      statusLabel = "Pending Registrar Decision";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.REJECTED:
      statusLabel = "Rejected";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.CANCELLED:
      statusLabel = "Cancelled";
      break;
    case MAINTAIN_COMPANY_REVIEW_STATUSES.PROCESSED:
      statusLabel = "Processed";
      break;
    case "SIGNATURE-DEFERRED":
      statusLabel = "Signature Deferred";
      break;
    default:
      statusLabel = "N/A";
  }
  return statusLabel;
};

const getBusinessDocumentData = () => {
  return [
    { label: "Form CR1", name: "formCR1", accept: "application/pdf" },
    { label: "Form CR2", name: "formCR2", accept: "application/pdf" },
    {
      label: "Statement of Nominal Capital",
      name: "statementOfNominalCapital",
      accept: "application/pdf",
    },
    {
      label: "Articles of Association",
      name: "articlesOfAssociation",
      accept: "application/pdf",
    },
    { label: "Form CR8", name: "formCR8", accept: "application/pdf" },
    { label: "Form CR10", name: "formCR10", accept: "application/pdf" },
    { label: "Form CR12", name: "formCR12", accept: "application/pdf" },
    {
      label: "Form BOF1",
      name: "formBOF1",
      accept: "application/pdf",
      optional: true,
    },
  ];
};

export {
  COMPANY_SECRETARY_FOREIGN_RESIDENT,
  COMPANY_SECRETARY_KENYAN,
  COMPANY_SECRETARY_LOCAL_COMPANY,
  FOREIGNER,
  FOREIGN_COMPANY,
  FOREIGN_RESIDENT,
  KENYAN_CITIZEN,
  MINOR,
  LOCAL_COMPANY,
  OTHER,
  REGULATED_ARTICLES,
  SPECIAL_INSTRUCTIONS,
  RESIGNATION_OFFICIAL,
  APPOINTMENT_OFFICIAL,
  getDocumentData,
  getOnboardingDocuments,
  getEstateDocumentData,
  getCompanySecretaryDocumentData,
  getBusinessDocumentData,
  getChangedDocumentsModuleData,
  getMaintainYourCompanyReviewStatus,
  getDocumentDataForEmployee,
  getSignOffManageDocuments,
};
